module.exports = __webpack_public_path__ + "static/media/twsModal.9a3dc584.png";